function FaceHelper( str ) { 
 this.original = str
 this.elements = this.parse(str)
}

FaceHelper.create = function ( str ) { 
 return new FaceHelper(str)
}

FaceHelper.prototype.regexp = /\[[a-zA-Z0-9\u4E00-\u9FA5]+\]/g

FaceHelper.prototype.parse = function ( str ) { 

 var tempStr = str
 var matches = tempStr.match(this.regexp) || []
 var resultArray = []

 matches.forEach(function (element) { 
  var location = tempStr.indexOf(element)
  if (location > 0) {
   resultArray.push({
    'type':'text',
    'value':tempStr.substr(0,location)
   })
  }
  resultArray.push({
   'type':'image',
   'value':FaceHelper.prototype.trimMarks(element)
  })
  tempStr = tempStr.substring(location+element.length)
 })

 if (tempStr) {
  resultArray.push({
   'type':'text',
   'value':tempStr
  })
 } 

 return resultArray
}

FaceHelper.prototype.trimMarks = function ( str ) { 
 if (!str) return ''
 return str.substring(1,str.length - 1)
}

export default FaceHelper